module.exports = {
  DEPLOY_ENV_NAME: 'TEST',
  API_REST_BE: '/',
  BASE_URL: '/'
};